import { AhuaIcon } from '@yaradigitallabs/ahua-react';
import { fileUploadStatusText } from './bulkImportConstants';

type FileUploadStatusProps = {
  progress: number;
  file?: File | null;
  cancelUpload?: () => void;
};

const FileUploadStatus = ({
  progress,
  file,
  cancelUpload,
}: FileUploadStatusProps) => {
  const fileSizeLabel = file
    ? file.size >= 1024 * 1024
      ? `${(file.size / (1024 * 1024)).toFixed(2)} MB`
      : `${(file.size / 1024).toFixed(2)} KB`
    : '';

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 p-3 m-4">
      {file ? (
        <div className="flex w-full items-center">
          <AhuaIcon icon="File" size="xl" colorConcept="neutral" />
          <div className="file-upload flex-1 ml-3 mr-3">
            <div className="file-content">
              <div className="flex w-full items-center justify-between">
                <span className="truncate text-gray-700 font-bold">
                  {file.name}
                </span>
                {progress < 100 && (
                  <span className="text-gray-400 font-bold">{progress}%</span>
                )}
              </div>
            </div>
            {progress < 100 ? (
              <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
                <div
                  className="h-full rounded-full bg-green-800 transition-all duration-300"
                  style={{ width: `${progress}%` }}
                />
              </div>
            ) : (
              <span className="text-gray-400 font-bold">{fileSizeLabel}</span>
            )}
          </div>
          <button
            type="button"
            onClick={() => {
              cancelUpload?.();
            }}
            className="flex h-6 w-6 items-center justify-center rounded-full hover:bg-gray-100"
          >
            {progress < 100 ? (
              <AhuaIcon icon="ClearCircle" size="s" colorConcept="neutral" />
            ) : (
              <AhuaIcon icon="Delete" size="s" colorConcept="neutral" />
            )}
          </button>
        </div>
      ) : (
        <div className="flex w-full items-center justify-center py-4 text-sm text-gray-400">
          {fileUploadStatusText.EMPTY_FILE_INFO}
        </div>
      )}
    </div>
  );
};

export default FileUploadStatus;
